function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useMemo, useCallback, useEffect, useRef } from 'react';
import { compareDateTime, compareYear, compareMonth, compareDate, compareHours, compareMinutes, compareSeconds, nextMonth, parseDate as parseDateTime, formatDate as formatDateTime, parseDateArr, formatDateArr, isString, getDocument } from '@bydesign-ui/utils';
import { useLocale, usePrefixCls } from '@byte-design/config';
import { useRefCallback, useAutoControlled, useAutoControlledBoolean, useForceUpdate } from '@bydesign-ui/hooks';
import { combineClasses } from '@bydesign-ui/utils';
import { PopperWrapper } from '../../units/date';
import { DateContentRender } from '../../units/date/layout/DateContentRender';
import { Time } from '../../units/date/layout/Time';
import { RcPopper } from '../../hooks/popper';
import { PanelType, useRangeDate } from '../../hooks/date';
import { TimePanel } from '../time-panel';
import { Button } from '../button/Button';

function updateRangePanelDate(rd, newVal) {
  var leftPanel = rd.getPanel('left');
  var rightPanel = rd.getPanel('right');

  var _newVal = _slicedToArray(newVal, 2),
      start = _newVal[0],
      end = _newVal[1];

  if (!newVal.length) {
    start = end = new Date();
  }

  leftPanel.updateDate(start, true);
  rightPanel.updateDate(!compareDateTime('month', start, end) ? nextMonth(start) : end, true);
  setRangePanelDate(rd);
}

function setRangePanelDate(root) {
  var leftPanel = root.getPanel('left');
  var rightPanel = root.getPanel('right');
  var leftDate = leftPanel.getDate();
  var rightDate = rightPanel.getDate();

  if (rightDate.getFullYear() === leftDate.getFullYear() && rightDate.getMonth() - leftDate.getMonth() === 1) {
    !leftPanel.getHideNext() && leftPanel.setHideNext(true);
    !rightPanel.getHidePrev() && rightPanel.setHidePrev(true);
  } else {
    leftPanel.getHideNext() && leftPanel.setHideNext(false);
    rightPanel.getHidePrev() && rightPanel.setHidePrev(false);
  }
}

export function DateTimeRangePicker(props) {
  var locale = useLocale('date');
  var propsValue = props.value,
      _onChange = props.onChange,
      onValueChange = props.onValueChange,
      propsOnAddStartValue = props.onAddStartValue,
      propsOnAddEndValue = props.onAddEndValue,
      onAddValue = props.onAddValue,
      _props$format = props.format,
      format = _props$format === void 0 ? locale.defaultFormat.dateTime : _props$format,
      offset = props.offset,
      _props$presets = props.presets,
      presets = _props$presets === void 0 ? [] : _props$presets,
      disabled = props.disabled,
      clearable = props.clearable,
      _props$placeholder = props.placeholder;
  _props$placeholder = _props$placeholder === void 0 ? [] : _props$placeholder;

  var _props$placeholder2 = _slicedToArray(_props$placeholder, 2),
      placeHolderStart = _props$placeholder2[0],
      placeHolderEnd = _props$placeholder2[1],
      placement = props.placement,
      size = props.size,
      width = props.width,
      propsOnHide = props.onHide,
      propsOnShow = props.onShow,
      disabledStart = props.disabledStart,
      disabledEnd = props.disabledEnd,
      propMin = props.min,
      propMax = props.max,
      propIsYearDisabled = props.isYearDisabled,
      propIsMonthDisabled = props.isMonthDisabled,
      propIsDateDisabled = props.isDateDisabled,
      outRangeDisabled = props.outRangeDisabled,
      needRangeValid = props.needRangeValid,
      _props$startDay = props.startDay,
      startDay = _props$startDay === void 0 ? locale.startDay : _props$startDay,
      propDisabledHours = props.disabledHours,
      propDisabledMinutes = props.disabledMinutes,
      propDisabledSeconds = props.disabledSeconds,
      showHour = props.showHour,
      showMinute = props.showMinute,
      showSecond = props.showSecond,
      hourStep = props.hourStep,
      minuteStep = props.minuteStep,
      secondStep = props.secondStep,
      className = props.className,
      popoverClassName = props.popoverClassName,
      popoverWrapperClassName = props.popoverWrapperClassName,
      extra = _objectWithoutProperties(props, ["value", "onChange", "onValueChange", "onAddStartValue", "onAddEndValue", "onAddValue", "format", "offset", "presets", "disabled", "clearable", "placeholder", "placement", "size", "width", "onHide", "onShow", "disabledStart", "disabledEnd", "min", "max", "isYearDisabled", "isMonthDisabled", "isDateDisabled", "outRangeDisabled", "needRangeValid", "startDay", "disabledHours", "disabledMinutes", "disabledSeconds", "showHour", "showMinute", "showSecond", "hourStep", "minuteStep", "secondStep", "className", "popoverClassName", "popoverWrapperClassName"]);

  var localePlaceholderStart = placeHolderStart !== null && placeHolderStart !== void 0 ? placeHolderStart : useLocale('date-time-picker.start');
  var localePlaceholderEnd = placeHolderEnd !== null && placeHolderEnd !== void 0 ? placeHolderEnd : useLocale('date-time-picker.end');
  var localeConfirm = useLocale('date-time-picker.ok');
  var ref = useRef(null);
  var refPanel = useRef(null);
  var parseDate = useRefCallback(function (value) {
    return parseDateTime(value, format, locale);
  });
  var formatDate = useRefCallback(function (value) {
    return formatDateTime(value, format, locale);
  });
  var parseTime = useRefCallback(function (value) {
    return parseDateTime(value, locale.defaultFormat.time, locale);
  });
  var formatTime = useRefCallback(function (value) {
    return formatDateTime(value, locale.defaultFormat.time, locale);
  });
  var parts = useMemo(function () {
    return ['left', 'right'];
  }, []);
  var onAddStartValue = useRefCallback(propsOnAddStartValue);
  var finalPropsValue = propsValue === null || propsValue === void 0 ? void 0 : propsValue.map(function (v) {
    return parseDate(v);
  }).map(function (v) {
    return v && formatDate(v);
  });

  var _useAutoControlled = useAutoControlled({
    defaultValue: [],
    value: finalPropsValue,
    onChange: function onChange(v) {
      _onChange === null || _onChange === void 0 ? void 0 : _onChange(v);
      onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(v);
    }
  }),
      _useAutoControlled2 = _slicedToArray(_useAutoControlled, 2),
      values = _useAutoControlled2[0],
      setValues = _useAutoControlled2[1];

  var forceUpdate = useForceUpdate();

  var _useState = useState(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      start = _useState2[0],
      setStart = _useState2[1];

  var _useState3 = useState(undefined),
      _useState4 = _slicedToArray(_useState3, 2),
      end = _useState4[0],
      setEnd = _useState4[1];

  var _useState5 = useState(undefined),
      _useState6 = _slicedToArray(_useState5, 2),
      point = _useState6[0],
      _setPoint = _useState6[1];

  var _useState7 = useState(),
      _useState8 = _slicedToArray(_useState7, 2),
      lastPoint = _useState8[0],
      setLastPoint = _useState8[1];

  var setPoint = useRefCallback(function (v) {
    setLastPoint(point);

    _setPoint(v);
  });
  var resetStates = useRefCallback(function () {
    var _values = _slicedToArray(values, 2),
        startValue = _values[0],
        endValue = _values[1];

    setStart(startValue && parseDate(startValue) || undefined);
    setEnd(endValue && parseDate(endValue) || undefined);
  });

  var _useAutoControlledBoo = useAutoControlledBoolean({
    defaultValue: false,
    onTrue: propsOnShow,
    onFalse: propsOnHide
  }),
      _useAutoControlledBoo2 = _slicedToArray(_useAutoControlledBoo, 2),
      visible = _useAutoControlledBoo2[0],
      _useAutoControlledBoo3 = _useAutoControlledBoo2[1],
      setVisible = _useAutoControlledBoo3.setValue,
      show = _useAutoControlledBoo3.setTrue,
      hide = _useAutoControlledBoo3.setFalse;

  useEffect(function () {
    var doc = getDocument();

    if (doc) {
      var onClickOutside = function onClickOutside(event) {
        if (!ref.current || ref.current === event.target || ref.current.contains(event.target) || !refPanel.current || refPanel.current === event.target || refPanel.current.contains(event.target)) {
          return;
        }

        hide();
      };

      doc.addEventListener('mousedown', onClickOutside);
      return function () {
        doc.removeEventListener('mousedown', onClickOutside);
      };
    }
  }, []);
  useEffect(function () {
    if (!visible) {
      resetStates();
      setLastPoint(undefined);
      root.resetTryingState();
      root.revertPanelSelected();
      root.repaintPanel();
    }
  }, [visible]);
  useEffect(function () {
    if (visible) {
      if (!point) {
        if (disabledStart) {
          setPoint('end');
        }

        if (disabledEnd) {
          setPoint('start');
        }
      }
    } else {
      resetStates();
    }
  }, [values[0], values[1]]);

  var _useMemo = useMemo(function () {
    var min = propMin ? isString(propMin) ? parseDate(propMin) : propMin : undefined;
    var max = propMax ? isString(propMax) ? parseDate(propMax) : propMax : undefined;

    var createRangeDisabled = function createRangeDisabled(compare) {
      return function (date, point) {
        return min && compare(min, date) > 0 || max && compare(max, date) < 0 || false;
      };
    };

    var rangeDisabledCallbacks = [compareYear, compareMonth, compareDate].map(createRangeDisabled);
    var rangeDisabledTimeCallbacks = [compareHours, compareMinutes, compareSeconds].map(function (compare, index) {
      var rangeDisabled = createRangeDisabled(compare);
      return function (value, _ref) {
        var date = _ref.date,
            point = _ref.point;

        if (!date) {
          return false;
        }

        return rangeDisabled(date, point);
      };
    });
    return [rangeDisabledCallbacks, rangeDisabledTimeCallbacks];
  }, [propMin, propMax]),
      _useMemo2 = _slicedToArray(_useMemo, 2),
      _useMemo2$ = _slicedToArray(_useMemo2[0], 3),
      rangeDisabledYear = _useMemo2$[0],
      rangeDisabledMonth = _useMemo2$[1],
      rangeDisabledDate = _useMemo2$[2],
      _useMemo2$2 = _slicedToArray(_useMemo2[1], 3),
      rangeDisabledHours = _useMemo2$2[0],
      rangeDisabledMinutes = _useMemo2$2[1],
      rangeDisabledSeconds = _useMemo2$2[2];

  var wrapDisabled = function wrapDisabled(defaultCallback) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultCallback;
    return function (date) {
      return callback(date, point);
    };
  };

  var wrapDisabledTime = function wrapDisabledTime(setter, defaultCallback) {
    var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultCallback;
    return function (value) {
      var date = point === 'start' ? start : end;

      if (!date) {
        return true;
      }

      date = date && new Date(date);
      date === null || date === void 0 ? void 0 : date[setter](value);
      var info = {
        date: date,
        point: point
      };
      return callback(value, info);
    };
  };

  var isYearDisabled = useRefCallback(wrapDisabled(rangeDisabledYear, propIsDateDisabled));
  var isMonthDisabled = useRefCallback(wrapDisabled(rangeDisabledMonth, propIsMonthDisabled));
  var isDateDisabled = useRefCallback(wrapDisabled(rangeDisabledDate, propIsDateDisabled));
  var disabledHours = useRefCallback(wrapDisabledTime('setHours', rangeDisabledHours, propDisabledHours));
  var disabledMinutes = useRefCallback(wrapDisabledTime('setMinutes', rangeDisabledMinutes, propDisabledMinutes));
  var disabledSeconds = useRefCallback(wrapDisabledTime('setSeconds', rangeDisabledSeconds, propDisabledSeconds));
  var onDateChange = useRefCallback(function (newDateValues) {});
  var onSetPreset = useRefCallback(function (preset) {
    if (preset.value.length !== 2) {
      console.warn('The length of preset is incorrect');
      return;
    }

    var newDateArr = parseDateArr(preset.value, format, locale, true);
    var newValArr = formatDateArr(preset.value, format, locale);
    setStart(newDateArr[0]);
    setEnd(newDateArr[1]);
    setValues(newValArr);
    hide();
  });
  var startTime = start && formatTime(start) || '';
  var onStartTimeChange = useRefCallback(function (value) {
    var newTime = parseTime(value);

    if (!newTime) {
      return;
    }

    if (start) {
      newTime.setFullYear(start.getFullYear(), start.getMonth(), start.getDate());
    }

    var formatted = formatDate(newTime);
    setStart(newTime);
    onAddStartValue(formatted);
  });
  var endTime = end && formatTime(end) || '';
  var onEndTimeChange = useRefCallback(function (value) {
    var newTime = parseTime(value);

    if (!newTime) {
      return;
    }

    if (end) {
      newTime.setFullYear(end.getFullYear(), end.getMonth(), end.getDate());
    }

    setEnd(newTime);
  });
  var onStartDateChange = useRefCallback(function (root, newDate, reversed) {
    if (start) {
      newDate.setHours(start.getHours());
      newDate.setMinutes(start.getMinutes());
      newDate.setSeconds(start.getSeconds());
    }

    var formatted = formatDateTime(newDate, locale.defaultFormat.dateTime, locale);
    setStart(newDate);
    onAddStartValue(formatted);
  });
  var onEndDateChange = useRefCallback(function (root, newDate, reversed) {
    if (end) {
      newDate.setHours(end.getHours());
      newDate.setMinutes(end.getMinutes());
      newDate.setSeconds(end.getSeconds());
    }

    var formatted = formatDateTime(newDate, locale.defaultFormat.dateTime, locale);
    setEnd(newDate);
  });
  var onConfirm = useRefCallback(function () {
    var updateValues = function updateValues(start, end) {
      setValues([start, end].map(function (v) {
        return v instanceof Date && formatDateTime(v, format, locale) || v;
      }));
      hide();
      setPoint(undefined);
    };

    if (point === 'start' && start) {
      onAddValue === null || onAddValue === void 0 ? void 0 : onAddValue(formatDateTime(start, format, locale), point);

      if (disabledEnd) {
        updateValues(start, propsValue === null || propsValue === void 0 ? void 0 : propsValue[1]);
        return;
      }

      if (!end) {
        setPoint('end');
        return;
      }

      if (start.getTime() > end.getTime()) {
        root.innerValue = [start];
        root.endValue = undefined;
        root.setTryingState(start);
        setEnd(undefined);
        setPoint('end');
        return;
      }

      updateValues(start, end);
      return;
    }

    if (point === 'end' && end) {
      onAddValue === null || onAddValue === void 0 ? void 0 : onAddValue(formatDateTime(end, format, locale), point);

      if (disabledStart) {
        updateValues(propsValue === null || propsValue === void 0 ? void 0 : propsValue[0], end);
        return;
      }

      if (!start) {
        setPoint('start');
        return;
      }

      if (start.getTime() > end.getTime()) {
        root.innerValue = [end];
        root.startValue = end;
        root.endValue = undefined;
        root.setTryingState(end);
        setStart(end);
        setEnd(undefined);
        setPoint('end');
        return;
      }

      updateValues(start, end);
      return;
    }
  });
  var onCancel = useRefCallback(function () {
    hide();
  });
  var onClear = useRefCallback(function () {
    if (!disabledStart && !disabledEnd) {
      setStart(undefined);
      setEnd(undefined);
      setValues([]);
    } else if (disabledStart) {
      setEnd(undefined);
      var startValue = (propsValue === null || propsValue === void 0 ? void 0 : propsValue[0]) || '';
      setValues([startValue, '']);
    } else if (disabledEnd) {
      setStart(undefined);
      var endValue = (propsValue === null || propsValue === void 0 ? void 0 : propsValue[0]) || '';
      setValues(['', endValue]);
    }

    root.resetTryingState();
    root.revertPanelSelected();
    root.repaintPanel();
  });

  var _useRangeDate = useRangeDate({
    locale: _objectSpread(_objectSpread({}, locale), {}, {
      startDay: startDay
    }),
    value: [start, end].map(function (v) {
      return v && formatDateTime(v, locale.defaultFormat.date, locale) || '';
    }),
    onChange: onDateChange,
    onStartValueChange: onStartDateChange,
    onEndValueChange: onEndDateChange,
    format: locale.defaultFormat.date,
    offset: offset,
    disabled: disabled,
    needRangeValid: needRangeValid,
    isYearDisabled: isYearDisabled,
    isMonthDisabled: isMonthDisabled,
    isDateDisabled: isDateDisabled,
    startDay: startDay,
    onUpdatePanelDate: updateRangePanelDate,
    onSetPanelDate: setRangePanelDate,
    panelType: PanelType.DATE,
    parts: parts,
    point: point
  }),
      root = _useRangeDate.root,
      onSetPresetTrying = _useRangeDate.onSetPresetTrying,
      onCancelPresetTrying = _useRangeDate.onCancelPresetTrying;

  var onResetPanel = useCallback(function () {
    var _values2 = _slicedToArray(values, 2),
        startValue = _values2[0],
        endValue = _values2[1];

    var _map = [startValue, endValue].map(function (v) {
      return v && parseDateTime(v, format, locale) || undefined;
    }),
        _map2 = _slicedToArray(_map, 2),
        startDate = _map2[0],
        endDate = _map2[1];

    setPoint(undefined);
    root.innerValue = [startDate, endDate].filter(function (v) {
      return !!v;
    });
    root.startValue = startDate;
    root.endValue = endDate;
  }, []);
  var activeStart = useRefCallback(function (e) {
    e.preventDefault();
    e.stopPropagation();

    if (visible) {
      hide();
      setPoint(undefined);
      return;
    }

    show();
    setPoint('start');
  });
  var activeEnd = useRefCallback(function (e) {
    e.preventDefault();
    e.stopPropagation();

    if (visible) {
      hide();
      setPoint(undefined);
      return;
    }

    show();
    setPoint('end');
  });
  var cls = usePrefixCls('date-time-range-picker');
  var popperCls = usePrefixCls('date-time-range-picker-popper');
  var contentCls = usePrefixCls('date-time-range-picker-body');
  var datePanelCls = usePrefixCls('date-time-range-picker-date-panel');
  var timeWrapperCls = usePrefixCls('date-time-range-picker-time-wrapper');
  var timeHeaderCls = usePrefixCls('date-time-range-picker-time-header');
  var timePanelCls = usePrefixCls('date-time-range-picker-time-panel');
  var footerCls = usePrefixCls('date-time-range-picker-footer');
  var confirmCls = usePrefixCls('date-time-range-picker-confirm');
  var inputCls = usePrefixCls('date-time-range-picker-input');
  var tildeCls = usePrefixCls('date-time-range-picker-tilde');
  var itemCls = usePrefixCls('date-time-range-picker-item');
  var itemClsDisabled = usePrefixCls('date-time-range-picker-item', {
    disabled: true
  });
  var itemActiveCls = usePrefixCls('date-time-range-picker-item-active');
  var valueCls = usePrefixCls('date-time-range-picker-value');
  var placeholderCls = usePrefixCls('date-time-range-picker-placeholder');
  var renderInput = useRefCallback(function () {
    var _map$map = [start, end].map(function (v) {
      return v && formatDateTime(v, format, locale);
    }).map(function (v, index) {
      var current = index === 0 && 'start' || 'end';
      var disabled = index === 0 ? disabledStart : disabledEnd;
      var onClick = index === 0 && activeStart || activeEnd;
      var placeholder = index === 0 ? localePlaceholderStart : localePlaceholderEnd;
      return React.createElement("button", {
        key: current,
        className: combineClasses(disabled && itemClsDisabled || itemCls, visible && current === point && itemActiveCls),
        disabled: disabled,
        onClick: !disabled && onClick || undefined
      }, v && React.createElement("span", {
        className: valueCls
      }, v) || React.createElement("span", {
        className: placeholderCls
      }, placeholder));
    }),
        _map$map2 = _slicedToArray(_map$map, 2),
        startContent = _map$map2[0],
        endContent = _map$map2[1];

    return React.createElement("div", {
      className: inputCls,
      onFocus: function onFocus(e) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, startContent, React.createElement("span", {
      className: tildeCls
    }, "~"), endContent);
  });
  return React.createElement("div", Object.assign({}, extra, {
    ref: ref,
    className: combineClasses(cls, className)
  }), React.createElement(RcPopper, null, React.createElement(PopperWrapper, Object.assign({
    triggerType: "manual"
  }, {
    show: visible,
    onShow: show,
    onHide: hide,
    onVisibleChange: setVisible,
    onClear: onClear,
    disabled: disabled,
    clearable: clearable,
    placement: placement,
    size: size,
    width: width
  }, {
    datasource: [values.join('~') || ''].map(function (v) {
      return {
        label: v,
        value: v
      };
    }),
    readOnly: true,
    className: popoverClassName,
    wrapperClassName: popoverWrapperClassName,
    renderPlaceholder: renderInput,
    renderSelected: renderInput
  }), React.createElement("div", {
    ref: refPanel,
    className: combineClasses(popperCls)
  }, React.createElement("div", {
    className: contentCls
  }, React.createElement(DateContentRender, {
    key: "date",
    className: datePanelCls,
    enableInvalidTooltip: true,
    parts: parts,
    root: root,
    onResetPanel: onResetPanel,
    resetOnMouseLeave: false,
    presets: presets,
    onPresetItemClick: onSetPreset,
    onPresetItemMouseEnter: onSetPresetTrying,
    onPresetItemMouseLeave: onCancelPresetTrying,
    singlePanel: true
  }), React.createElement("div", {
    key: "time",
    className: timeWrapperCls
  }, React.createElement("div", {
    key: "header",
    className: timeHeaderCls
  }, [point === 'start' ? start : end].map(function (v) {
    return v && React.createElement(Time, {
      date: v
    });
  })[0]), [['start', startTime, onStartTimeChange], ['end', endTime, onEndTimeChange]].map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 3),
        key = _ref3[0],
        value = _ref3[1],
        onChange = _ref3[2];

    return key === point && React.createElement(TimePanel, {
      key: key,
      className: timePanelCls,
      value: value,
      onChange: onChange,
      format: locale.defaultFormat.time,
      hourStep: hourStep,
      minuteStep: minuteStep,
      secondStep: secondStep,
      showHour: showHour,
      showMinute: showMinute,
      showSecond: showSecond,
      disabledHours: disabledHours,
      disabledMinutes: disabledMinutes,
      disabledSeconds: disabledSeconds
    });
  }))), React.createElement("div", {
    className: footerCls
  }, React.createElement(Button, {
    className: confirmCls,
    type: "primary",
    size: "xs",
    onClick: onConfirm
  }, localeConfirm))))));
}